// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"e61d6c25","498":"b3f6f40c"}[chunkId] + ".chunk.js";
};